import { apiRequest } from "../../index";

export const confirmTableReservation = async ({reservationId , data}) => {
  return apiRequest(`/api/owner/restaurant/confirm-table/${reservationId}`, "PUT" , data);
};

export const cancelBooking = async ({reservationId}) => {
  return apiRequest(`/api/owner/restaurant/cancel/booking/${reservationId}`, "PUT" );
};

export const deleteBooking = async ({reservationId}) => {
  return apiRequest(`/api/owner/restaurant/table/booking/${reservationId}`, "DELETE" );
};

export const getAllReservations = async ({page , limit , status , search}) => {
  return apiRequest(`/api/owner/restaurant/table/reservations?page=${page}&limit=${limit}&status=${status}&search=${search}`, "GET");
};

export const getReservationDetail = async (reservationId) => {
  return apiRequest(`/api/owner/restaurant/table/reservations/${reservationId}`, "GET");
};

// Orders Management

export const getAllOrders = async ({page , limit, search = "", status = ""}) => {
  const params = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
  });
  
  if (search) {
    params.append("search", search);
  }
  
  if (status) {
    params.append("status", status);
  }
  
  return apiRequest(`/api/owner/restaurant/orders/all?${params.toString()}`, "GET");
};

export const getOrderDetail = async (orderId) => {
  return apiRequest(`/api/owner/restaurant/orders/${orderId}`, "GET");
};

export const deleteOrder = async (orderId) => {
  return apiRequest(`/api/owner/restaurant/orders/${orderId}`, "DELETE" );
};

export const updateOrderStatus = async ({orderId, status}) => {
  return apiRequest(`/api/owner/restaurant/orders/status/${orderId}`, "PUT", { status });
};